<template>
  <div class="patient-case">
    <div class="row mr-3 align-items-center">
      <div class="col">
        <img src="@/assets/logo_new.png" width="200" class="py-3" />
      </div>
      <div class="col-auto text-right" v-if="assignee">
        <h5 class="uppercase">
          {{ assignee.firstname[authLocale] }}
          {{ assignee.lastname[authLocale] }}
        </h5>
        <h5 class="uppercase mb-0">
          {{ assignee.phone_number }}
        </h5>
      </div>
    </div>
    <hr class="mt-0" />
    <div class="mx-3 pt-3">
      <table
          class="table table-hover table-bordered table-striped"
          v-if="caseById(value)"
        >
        <thead class="thead-light">
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("gender") }}</th>
            <th>{{ $t("age") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ caseById(value).schedule.patient.firstname[authLocale] }} {{ caseById(value).schedule.patient.lastname[authLocale] }}</td>
            <td>{{ $t(caseById(value).schedule.patient.gender) }}</td>
            <td>{{ caseById(value).schedule.patient.age }} {{ $t(caseById(value).schedule.patient.age_unit) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="patient-case-item"
      v-for="sec of sections"
      :key="sec"
      :class="{ open: open[sec] }"
    >
      <template v-if="sec != 'FileUpload' && sec != 'Labtests' && sec != 'Infermedica' && sec != 'References'">
        <h3 class="patient-case-title d-block p-3 m-0">
          {{ $t(sec) }}
        </h3>
        <div class="patient-case-content">
          <div class="pb-3 px-3">
            <components
              :is="sec"
              :value="value"
              :report="true"
              v-if="value && caseById(value)"
            ></components>
          </div>
        </div>
      </template>
    </div>
    <div v-if="caseById(value) && caseById(value).schedule.checkup_device === 'T8X'">
      <T8x :checkup="t8x" :include-patient-data="false" :rotate-pceeg="true"></T8x>
    </div>

    <div v-if="caseById(value) && caseById(value).schedule.checkup_device === 'GS2'">
      <Gs2 :checkup="gs2" :include-patient-data="false" :rotate-pceeg="true"></Gs2>
    </div>
    
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import AngleIcon from "@/components/Icons/Angle";
import Schedules from "@/components/Cases/Views/Schedules";
import Evidences from "@/components/Cases/Views/Evidences";
import Diagnosis from "@/components/Cases/Views/Diagnosis";
import FileUpload from "@/components/Cases/Views/FileUpload";
import Conclusion from "@/components/Cases/Views/Conclusion";
import ServiceRequests from "@/components/Cases/Views/ServiceRequests";
import Comment from "@/components/Cases/Views/Comment";
import Labtests from "@/components/Cases/Views/Labtests";
import Treatment from "@/components/Cases/Views/Treatment";
import References from "@/components/Cases/Views/References";
import Infermedica from "@/components/Cases/Sections/Infermedica";
import T8x from "@/components/Checkups/T8x";
import Gs2 from "@/components/Checkups/Gs2";
export default {
  components: {
    Evidences,
    Schedules,
    Diagnosis,
    FileUpload,
    Conclusion,
    Comment,
    Labtests,
    Treatment,
    AngleIcon,
    ServiceRequests,
    References,
    Infermedica,
    T8x,
    Gs2
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      open: {
        FileUpload: false,
        Comment: false,
        Diagnosis: false,
        Evidences: false,
        Conclusion: false,
        Labtests: false
      },
      loading: false,
      tx8data: null,
      gs2data: null,
      loadingDoctor: false,
      doctor: null
    };
  },
  computed: {
    ...mapGetters({
      caseById: "pcase/byId",
      servicetplById: "servicetpl/byId",
      t8xById: "checkup/t8xById",
      gs2ById: "checkup/gs2ById",
      authType: "auth/type",
      authLocale: "auth/locale"
    }),
    sections() {
      if (
        this.caseById(this.value) &&
        this.servicetplById(this.caseById(this.value).template)
      ) {
        if (this.authType === "Doctor") {
          return ["Schedules"].concat(
            this.servicetplById(this.caseById(this.value).template)
              .permitted_actions
          );
        }
        return this.servicetplById(this.caseById(this.value).template)
          .permitted_actions;
      }
      return null;
    },
    assignee() {
      if (this.doctor) {
        return this.doctor;
      }
      if (
        this.caseById(this.value) &&
        this.caseById(this.value).schedule.t8x_checkup_id
      ) {
        if (!this.loadingDoctor) {
          this.fetchDoctor(this.caseById(this.value).schedule.assignee_id);
        }
      }
      return null;
    },
    t8x() {
      if (this.tx8data) {
        return this.tx8data;
      }
      if (
        this.caseById(this.value) &&
        this.caseById(this.value).schedule.checkup_id
      ) {
        if (!this.loading) {
          this.fetchCheckups(
            this.caseById(this.value).schedule.checkup_id,
            () => {
              this.tx8data = this.t8xById(
                this.caseById(this.value).schedule.checkup_id
              );
            }
          );
        }
      }
      return null;
    },
    gs2() {
      if (this.gs2data) {
        return this.gs2data;
      }
      if (
        this.caseById(this.value) &&
        this.caseById(this.value).schedule.checkup_id
      ) {
        if (!this.loading) {
          this.fetchCheckups(
            this.caseById(this.value).schedule.checkup_id,
            () => {
              this.gs2data = this.gs2ById(
                this.caseById(this.value).schedule.checkup_id
              );
            }
          );
        }
      }
      return null;
    }
  },
  methods: {
    ...mapMutations({
      setError: "alert/setError",
      setCheckup: "checkup/set",
      setT8x: "checkup/setT8x",
      setGs2: "checkup/setGs2"
    }),
    secClicked(sec) {
      this.$set(this.open, sec, !this.open[sec]);
    },
    async fetchDoctor(id) {
      this.loadingDoctor = true;
      try {
        const response = await this.axios.get(`/api/doctors/${id}`);
        this.doctor = response.data.data;
        this.loadingDoctor = false;
      } catch (err) {
        this.setError(err);
        this.loadingDoctor = false;
      }
    },
    async fetchCheckups(id, cb) {
      // const checkup = this.checkupById(id)
      // if (checkup) {
      //   return
      // }
      try {
        const response = await this.axios.get(`/device/checkups/${id}`);
        const checkup = response.data.data;
        if (checkup.device_type === "T8X") {
          this.setT8x({
            MachineId: checkup.checkup.MachineId,
            MacAddr: checkup.checkup.MacAddr,
            UnitNo: checkup.checkup.UnitNo,
            UnitName: checkup.checkup.UnitName,
            doctor_id: checkup.checkup.doctor_id,
            DoctorName: checkup.checkup.DoctorName,
            RecordNo: checkup.checkup.RecordNo,
            MeasureTime: checkup.checkup.MeasureTime,
            LoginType: checkup.checkup.LoginType,
            DeviceType: checkup.checkup.DeviceType,
            Member: checkup.checkup.Member,
            Height: checkup.checkup.Height,
            Fat: checkup.checkup.Fat,
            MinFat: checkup.checkup.MinFat,
            BloodPressure: checkup.checkup.BloodPressure,
            Bo: checkup.checkup.Bo,
            PEEcg: checkup.checkup.PEEcg,
            Temperature: checkup.checkup.Temperature,
            Whr: checkup.checkup.Whr,
            BloodSugar: checkup.checkup.BloodSugar,
            Ua: checkup.checkup.Ua,
            Chol: checkup.checkup.Chol,
            BloodFat: checkup.checkup.BloodFat,
            ArteryAve: checkup.checkup.ArteryAve,
            interview_id: checkup.checkup.interview_id,
            userId: checkup.checkup.user_id
          });
        } else {
          this.setGs2({
            MachineID: checkup.checkup.MachineID,
            MacAddr: checkup.checkup.MacAddr,
            RecordNo: checkup.checkup.RecordNo,
            MeasureTime: checkup.checkup.MeasureTime,
            DeviceType: checkup.checkup.DeviceType,
            Member: checkup.checkup.Member,
            Height: checkup.checkup.Height,
            BloodPressure: checkup.checkup.BloodPressure,
            Bo: checkup.checkup.Bo,
            Temperature: checkup.checkup.Temperature,
            Whr: checkup.checkup.Whr,
            BloodSugar: checkup.checkup.BloodSugar,
            Ua: checkup.checkup.Ua,
            Chol: checkup.checkup.Chol,
            Urinalysis: checkup.checkup.Urinalysis,
            Hb: checkup.checkup.Hb,
            Vision: checkup.checkup.Vision,
            Tooth: checkup.checkup.Tooth,
            PEEcg: checkup.checkup.PEEcg,
            Ultrasonic: checkup.checkup.Ultrasonic,
            PsychologicalAssessment: checkup.checkup.PsychologicalAssessment,
            created_at: checkup.checkup.created_at,
            UserID: checkup.checkup.UserID,
            interview_id: checkup.checkup.interview_id
          });
        }
        this.setCheckup({
          RecordNo: checkup.record_no,
          deviceType: checkup.device_type,
          userId: checkup.user_id,
          created_at: checkup.created_at,
          sections: checkup.sections
        });
        cb();
        this.loading = false;
      } catch (err) {
        this.setError(err);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss">
.patient-case {
  font-size: 0.75em;
  .list {
    .item {
      small {
        transition: all 0.2s;
        svg {
          width: 16px;
          height: 16px;
          transition: all 0.2s;
        }
        &:hover {
          background-color: #eee;
        }
      }
      a,
      button,
      label {
        transition: all 0.2s;
        background-color: #fff;
        border: none;
        display: block;
        text-decoration: none;
        width: 100%;
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        color: #555;
        &:hover {
          background-color: #eee;
        }
        svg {
          width: 16px;
          height: 16px;
          transition: all 0.2s;
        }
        .closed {
          svg {
            transform: rotate(-90deg);
          }
        }
        .open {
          svg {
            transform: rotate(0deg);
          }
        }
      }
    }
    // .item-action {
    // }
    .item-last {
      a,
      button,
      label {
        border-right: 1px solid #ccc;
      }
    }
    .item-bottom {
      a,
      button,
      label {
        border-bottom: 1px solid #ccc;
        background-color: #eee;
      }
    }
  }

  .patient-case-item {
    transition: all 0.2s;
    border-bottom: 1px solid #eee;
    // box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    .patient-case-title {
      // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      // border-bottom: 1px solid #eee;
      &:hover {
        background-color: #f8f9fa;
      }
      svg {
        transition: all 0.2s;
        transform: rotate(-90deg);
        width: 16px;
        height: 16px;
      }
    }
    .patient-case-content {
      // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      border-bottom: 1px solid #eee;
      overflow: hidden;
    }
  }
}
</style>
<i18n>
{
    "ka": {
      "Schedules": "ქეისის ფარგლებში ჩატარებული კონსულტაციები",
      "finishCase": "ქეისის დასრულება",
      "FileUpload": "კვლევების შედეგები (ფაილები)",
      "Comment": "კომენტარი",
      "Diagnosis": "დიაგნოზი",
      "Evidences": "სიმპტომები",
      "Infermedica": "ხელოვნური ინტელექტის დასკვნა",
      "Conclusion": "დასკვნა",
      "Labtests": "ლაბორატორიული მონაცემები",
      "Treatment": "დანიშნულება",
      "ServiceRequests": "მოთხოვნილი სერვისები",
      "References": "მიმაგრებული ჩანაწერები",
      "name": "სახელი",
      "gender": "სქესი",
      "age": "ასაკი",
      "year": "წლის",
      "month": "თვის",
      "male": "მამრ.",
      "female":"მდედრ."
  },
  "en": {
    "Schedules": "Schedules within the case",
    "finishCase": "Finish Case",
    "FileUpload": "Results",
    "Comment": "Comment",
    "Diagnosis": "Diagnosis",
    "Evidences": "Evidences",
    "Infermedica": "AI Conclusion",
    "Conclusion": "Conclusion",
    "Labtests": "Labtests",
    "Treatment": "Treatment",
    "ServiceRequests": "Service Requests",
    "References": "References",
    "name": "Name",
    "gender": "Gender",
    "age": "Age",
    "year": "Years old",
    "month": "Months old",
    "male": "Male",
    "female":"Female"
  }
}
</i18n>
